import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpService } from 'src/app/core';
import { Utility } from 'src/app/core/utils/utility';

interface ApiConfig {
  endpoint: string;
  method: string;
  payload: any;
}

@Component({
  selector: 'app-otp-modal',
  templateUrl: './otp-modal.component.html',
  styleUrl: './otp-modal.component.scss'
})
export class OtpModalComponent {

  @Input() options: {
    heading?: string;
    successMessage?: string,
    sendCodeApi?: ApiConfig,
    verifyCodeApi?: ApiConfig,
  } = {};
  otp = {
    countdown: 5,//in seconds
    timer: null as any as ReturnType<typeof setInterval>,
    value: '',
    messageData: {
      errorArr: [] as any[],
      verified: ''
    }
  };
  otpConfig = {
    allowNumbersOnly: true,
    length: 6,
    disableAutoFocus: true
  };

  constructor(
    public activeModal: NgbActiveModal,
    private httpService: HttpService
  ) {
  }

  ngOnInit() {
    this.startCountdown();
    this.otp.messageData.verified = this.options.successMessage || '';
  }

  close(data?: any) {
    this.activeModal.close(data);
  }

  sendCode() {
    const payload = {
      ...this.options?.sendCodeApi?.payload
    };
    const method = this.options?.sendCodeApi?.method;
    if (method == 'POST' && this.options?.sendCodeApi?.endpoint) {
      this.httpService.post(this.options?.sendCodeApi?.endpoint, payload).subscribe((response: any) => {
        this.otp.messageData.verified = response?.message;
        this.otp.messageData.errorArr = [];
        this.startCountdown();
      }, (err) => {
        this.otp.countdown = 0;
        if (this.otp?.timer) {
          clearInterval(this.otp.timer);
        }
        this.showErrorInModal(err);
      });
    }
  }

  verifyCode() {
    const payload = {
      ...this.options?.verifyCodeApi?.payload,
      code: this.otp.value
    };
    const method = this.options?.verifyCodeApi?.method;
    if (method == 'POST' && this.options?.verifyCodeApi?.endpoint) {
      this.httpService.post(this.options?.verifyCodeApi?.endpoint, payload).subscribe((response: any) => {
        this.close(response?.message);
      }, (err) => {
        this.otp.countdown = 0;
        if (this.otp?.timer) {
          clearInterval(this.otp.timer);
        }
        this.showErrorInModal(err);
      });
    }
  }

  startCountdown() {
    this.otp.countdown = 5;
    if (this.otp?.timer) {
      clearInterval(this.otp.timer);
    }
    this.otp.timer = setInterval(() => {
      if (this.otp.countdown > 0) {
        this.otp.countdown--;
      } else {
        clearInterval(this.otp.timer);
      }
    }, 1000);
  }

  showErrorInModal(err: any) {
    this.otp.messageData.errorArr = [];
    this.otp.messageData.verified = '';
    if (err?.error?.message) {
      this.otp.messageData.errorArr = Utility.getErrorList(err?.error) ?? [];
    } else {
      this.otp.messageData.errorArr = ['Server Error, Please try again after some time.'];
    }
  }

  onOTPChange() {
    this.otp.messageData.errorArr = [];
    this.otp.messageData.verified = '';
  }

  ngOnDestroy() {
    if (this.otp?.timer) {
      this.otp.countdown = 0;
      clearInterval(this.otp.timer);
    }
  }
}
